import React from "react";
import { withAuthCreateContainer } from "./ContainerCreate";
import { getSleeveFavorites } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class FavoriteSleevesContainer extends React.Component {
  componentDidMount() {
    const page = this.props.page || 1;
    this.props.request(page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage } = nextProps;
    const { page } = this.props;
    if (nextPage !== page) {
      this.props.request(nextPage);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || [];
    const { favorites, perPage, more, total } = results;
    if (loading) {
      return <Skeleton count={3} />;
    }

    return render({ favorites, total, more, perPage, loading, failure });
  };
}

export default withAuthCreateContainer(getSleeveFavorites, FavoriteSleevesContainer);
